import { Component, OnInit, Input} from '@angular/core';
import { CommonService } from '../service/common.service';
import { MasterService } from '../service/master.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
    selector: 'yoyaku-maintenance-app',
    templateUrl: './yoyaku-maintenance.component.html',
    styleUrls: ['yoyaku-maintenance.component.css']
})
export class YoyakuMaintenanceComponent implements OnInit {
    title : string = '（予約）マスタメンテナンス';
    isLoaded : boolean = false;

    constructor(
        private commonService: CommonService,
        private masterService: MasterService,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location,
    ) { }

    ngOnInit(): void {
        this.isLoaded=true;
        //Loading停止
        this.commonService.loadingEnd();
    };
}



// WEBPACK FOOTER //
// ./src/app/a2120-yoyaku-maintenance/yoyaku-maintenance.component.ts